import { render } from "./insure-deduction.vue?vue&type=template&id=5b25423c&scoped=true&ts=true"
import script from "./insure-deduction.vue?vue&type=script&lang=ts"
export * from "./insure-deduction.vue?vue&type=script&lang=ts"

import "./insure-deduction.vue?vue&type=style&index=0&id=5b25423c&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b25423c"]])

export default __exports__